import { Observable, Subscriber, concat } from "rxjs";
import { retryWhen, share, takeUntil, finalize, map, scan, throttleTime } from "rxjs/operators";
import { BALData, BALObserverModel, BALRareStreamData, ProcessType } from "../../types";
import { errorHandler, setPubsubStream } from "../apiHelper";
import { getFactoryChangeObservable } from '../../Auth';
import { parseBALData, parseSingleBALmsg } from "./BALHelper";
import { withLogger } from "../LogerServices";
import { getBALInitialDataTwoLines } from "../ALCInitialDataServices/BALInitialDataService";
import { default as lodashMerge } from 'lodash/merge';

const BALType = ProcessType.BAL;

const BALObserver: BALObserverModel = {
    balObservable: null as Observable<BALData>,
};

const setBALStream = () => new Observable<BALRareStreamData>((observer: Subscriber<BALRareStreamData>) => {
    const close = setPubsubStream(observer, BALType);
    return close;
}).pipe(
    retryWhen(errors => errorHandler(errors)),
    map(parseBALData),
    map(parseSingleBALmsg),
    takeUntil(getFactoryChangeObservable()),
    share()
);

const BALDataObservable = () => {
    BALObserver.balObservable = concat(
        withLogger(getBALInitialDataTwoLines(), BALType, { isInitial: true }),
        withLogger(setBALStream(), BALType)
    ).pipe(
        scan((acc, val) => lodashMerge({}, acc, val), {}),
        throttleTime(1000),
        finalize(() => BALObserver.balObservable = null),
    )
    return BALObserver.balObservable
};

export const getBALDataObservable = (): Observable<BALData> => BALObserver.balObservable ? BALObserver.balObservable : BALDataObservable();